module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/zh-hant/4-f71cbca17fcddfda1446b54a5a9fb8b6.jpg";